import { getUserSettings, setUserSetting } from './userSettingsStorage';

const VIDEOS_MUTED_KEY = 'videosMuted';
const listeners = new Set();

export const getVideosMuted = () => getUserSettings()[VIDEOS_MUTED_KEY] === true;

export const setVideosMuted = (muted) => {
  setUserSetting({ key: VIDEOS_MUTED_KEY, value: muted });
  listeners.forEach((listener) => listener(muted));
};

export const subscribeVideosMuted = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
